var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 30C6.716 30 0 23.284 0 15S6.716 0 15 0s15 6.716 15 15-6.716 15-15 15m5.5-18.685a1.499 1.499 0 1 0-2.121-2.121l-3.532 3.532-3.532-3.532a1.499 1.499 0 1 0-2.121 2.121l3.532 3.532-3.532 3.532a1.499 1.499 0 1 0 2.121 2.121l3.532-3.532 3.532 3.532A1.499 1.499 0 1 0 20.5 18.38l-3.532-3.532z"
})));
export default SvgClose;